module.exports = __webpack_public_path__ + "img/slash.a10d4e72.svg";